import React from "react";
import Footer from "../Footer";
import Navbar from "../Navbar";
import ReferralSection from "../Referral";

const ClientReferral = () => {
  return (
    <div>
      <Navbar />
      <ReferralSection />
      <Footer />
    </div>
  );
};

export default ClientReferral;
